<template>
<div class="page">
    <Header title="今日运势" />
    <div class="scrollerView" :style="{ height: wrapperHeight + 'px' }">
        <scroller :on-refresh="refresh" :noDataText="commentList.length > 1 ? Constants.ALL_LOAD_TIPS : ''" :on-infinite="infinite" ref="infinite" class="scroller">
            <!-- <div class="top-img" v-if="dataSources.image">
            <img :src="dataSources.image" />
        </div> -->
            <div class="content">
                <h3>{{ dataSources.name }}</h3>
                <div v-html="dataSources.content"></div>
                <div class="nodata" v-if="!dataSources.content">小编正在努力中补充...</div>
            </div>
            <!-- 评论 -->
            <div class="comment-box">
                <div class="tit" ref="commentTitle">
                    <span>评论列表</span>
                </div>
                <commentItem v-for="(item, index) in commentList" :key="index" :item="item" />
                <van-empty description="暂无信息～" v-if="dataSources.length < 1 && !loading" />
            </div>
        </scroller>
    </div>
    <div class="footer">
        <div>
            <img :src="Images.icon_eyes" />
            <span>{{ dataSources.visits }}</span>
        </div>
        <div @click="onPressLike">
            <img :src="Images.icon_zan" />
            <span>{{ dataSources.likes }}</span>
        </div>
        <div @click="scrollToComment">
            <img :src="Images.icon_comment" />
            <span>{{ dataSources.comments }}</span>
        </div>
        <div @click="onPressShare">
            <img :src="Images.icon_fenxiang" />
            <span>{{ dataSources.shares }}</span>
        </div>
        <div class="td-f1 td-fec">
            <div class="input td-fsc" @click="showCommentInputModel">
                <img :src="Images.icon_edit" />
                <span>写留言</span>
            </div>
        </div>
    </div>
    <div class="history td-fc" @click="onPressNav('fortuneList')" v-if="type == 'home'">
        <span>历史</span>
        <span>运势</span>
    </div>
    <!-- 写评论 -->
    <comment-input image @callback="commentCannback" :show="showCommentInput"></comment-input>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import {wxSetup, wxShare} from '@/utils/wxShare'
import Header from "../../components/Header";
import CommentInput from "../../components/CommentInput";
import commentItem from "../../components/item/commentItem";
export default {
    components: {
        Header: Header,
        "comment-input": CommentInput,
        commentItem,
    },
    computed: {
        ...mapGetters(["userInfo", "service"]),
    },
    data() {
        return {
            loading: false,
            wrapperHeight: 0,
            id: "",
            type: "list",
            dataSources: {},
            // 评论
            showCommentInput: false,
            commentList: [],
            page: 0,
            limit: 10,
        };
    },
    created() {
        this.id = this.$route.query.id;
        this.type = this.$route.query.type;
        this.requestData();
    },
    mounted() {
        this.wrapperHeight = document.documentElement.clientHeight;
        setTimeout(() => {
            this._setupWechatConfig();
        }, 500);
    },
    methods: {

        // 设置分享参数
        async _setupWechatConfig() {
            let url = this.API.wx_setup_info;
            let data = {
                page_flag: 'common',
                share_url: window.location.href.split('#')[0],
            };

            let _urlTemp = window.location.href;
            if (_urlTemp.indexOf('is_share=1&uid=') > -1) {
                _urlTemp = _urlTemp.split('is_share=1&uid=')[0] + 'is_share=1&uid=' + this.userInfo.id;
            } else {
                _urlTemp = _urlTemp + '&is_share=1&uid=' + this.userInfo.id;
            }

            console.log('this.userInfo.id, _urlTemp---->', this.userInfo.id, _urlTemp);

            // 非微信环境直接退出
            if (!this.$isWeiXin()) return;
            let result = await this.$post(url, data);
            if (result.code == this.GLOBAL.SUCCESS_CODE) {
                let share_params = {
                    ...result.data.share_params,
                    title: this.dataSources.name,
                    desc: this.dataSources.desc,
                    icon: this.dataSources.cover,
                    link: _urlTemp,
                }
                console.log('share_params---->', share_params);
                wxShare(result.data.share_config, share_params, () => {});
            }
        },
        
        // 请求数据
        async requestData() {
            let url = this.API.destiny_detail;
            let params = {
                id: this.id,
                token: this.Lockr.get("token"),
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.dataSources = result.data;
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        // 获取评论
        refresh() {
            this.page = 1;
            this.requestDataComment();
            setTimeout(
                function () {
                    this.$refs.infinite.finishPullToRefresh();
                }.bind(this),
                1000
            );
        },
        infinite() {
            this.page++;
            setTimeout(() => {
                this.requestDataComment();
            }, 500);
        },
        async requestDataComment() {
            let url = this.API.destiny_comment_list;
            let params = {
                destiny_id: this.id,
                token: this.Lockr.get("token"),
                page: this.page,
                limit: this.limit,
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                let list = result.data.data || [];
                if (this.page === 1) {
                    this.commentList = list;
                } else {
                    this.commentList = this.commentList.concat(list);
                }
                this.$refs.infinite.finishInfinite(list.length < this.limit);
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        // 点赞喜欢
        async onPressLike() {
            let url = this.API.home_page_like;
            let params = {
                token: this.Lockr.get("token"),
                id: this.id,
                type: "destiny", // article:文章信息 destiny:运势点赞
            };
            let result = await this.$post(url, params);
            let that = this;
            this.Message({
                title: result.msg,
            });
            if (result.code === that.GLOBAL.SUCCESS_CODE) {
                this.requestData();
            }
        },
        // 点击分享
        async onPressShare() {
            this.$emit(this.Constants.SHOWSHAREPOPUP, true);
            let url = this.API.share_content;
            let params = {
                id: this.id,
                type: 3, // 0是文章，1是视频，2是音频，3是运势
            };
            let result = await this.$get(url, params);
        },
        onPressNav(router, query = {}) {
            this.$router.push({
                path: "/" + router,
                query: query
            });
        },
        showCommentInputModel() {
            this.showCommentInput = true;
        },
        commentCannback(res) {
            console.log("res", res);
            if (res.type == "cancel") {
                this.showCommentInput = false;
            } else if (res.type == "success") {
                this.submitComment(res.data);
            }
        },
        async submitComment(res) {
            let url = this.API.destiny_comment;
            let params = {
                destiny_id: this.id,
                token: this.Lockr.get("token"),
                comment: res.content,
                image: res.img_src,
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.Message({
                    title: result.msg,
                });
                this.showCommentInput = false;
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        // 滚动到评论
        scrollToComment() {
            let top = this.$refs.commentTitle.offsetTop;
            this.$refs.infinite.scrollTo(0, top, true);
        },
    },
};
</script>

<style lang="less" scoped>
.page {}

.scrollerView {
    position: relative;
    width: 100%;
    background-color: #fff;
}

.top-img {
    margin-bottom: 20px;

    img {
        width: 100%;
        display: block;
    }
}

.content {
    font-size: 14px;
    color: #333;
    line-height: 2;
    padding: 15px;

    h3 {
        font-size: 17px;
        line-height: 1.5;
        margin-bottom: 10px;
        text-align: justify;
        word-break: break-all;
        border-bottom: solid #dbdbdb 2px;
        padding-bottom: 10px;
        margin-bottom: 20px;
    }

    /deep/ img {
        max-width: 100%;
    }
}

.nodata {
    padding: 40px 0;
    font-size: 16px;
    color: #999;
    text-align: center;
}

.comment-box {
    border-top: solid #f8f8f8 10px;
    padding: 15px;

    .tit {
        margin-bottom: 10px;

        span {
            font-size: 16px;
            color: #6472e8;
            font-weight: 500;
            padding-left: 10px;
            line-height: 1;
            border-left: #6472e8 solid 4px;
        }
    }
}

.history {
    color: #fff;
    right: 10px;
    bottom: 90px;
    z-index: 100;
    width: 50px;
    height: 50px;
    padding: 10px;
    display: flex;
    position: fixed;
    font-size: 12px;
    line-height: 1.2;
    font-weight: 500;
    letter-spacing: 1px;
    align-items: center;
    border-radius: 25px;
    box-sizing: border-box;
    justify-content: center;
    background: linear-gradient(45deg, #7180eb, #d3d5e6);
    box-shadow: 0px 1px 6px 0px rgba(157, 157, 157, 0.2);
}

.footer {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 50px;
    background-color: #fff;
    box-sizing: border-box;
    padding: 0 15px;
    display: flex;
    align-items: center;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);

    >div {
        margin-right: 10px;
        display: flex;
        align-items: center;

        &:last-child {
            margin-right: 0;
            margin-left: 20px;
        }

        span {
            font-size: 14px;
            color: #666;
            padding-left: 3px;
        }

        img {
            width: 16px;
            height: 16px;
            margin-left: 5px;
        }

        .input {
            width: 100%;
            height: 26px;
            border-radius: 20px;
            border: solid #eee 1px;
            padding: 0 5px;
            color: #999;
            font-size: 12px;

            img {
                width: 16px;
                height: 16px;
            }

            span {
                font-size: 12px;
                color: #999;
            }
        }
    }
}
</style>
